import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    'submit',
    'registrationNumberInput',
    'showManualInput',
    'createCarManuallyText',
    'manualInputStep1',
    'manualInputStep2',
    'manualInputStep3',
    'manualInputStep4',
    'manualInputStep5',
    'makeInput',
    'modelInput',
    'yearInput',
    'fuelTypeInput',
    'submit'
  ];

  connect() {
    const registrationNumberElm = this.element.querySelector('#registration_number')

    if (registrationNumberElm) {
      this.submitTarget.disabled = !this.can_submit;
    }

    // Prevent submit on Enter
    const form = document.querySelector('form.new_job, form.edit_job');

    if (form) {
      form.onkeypress = function(e) {
        var key = e.charCode || e.keyCode || 0;
        if (key == 13) {
          e.preventDefault();
        }
      }
    }
  }

  get url() {
    return this.element.dataset.url;
  }

  registrationNumberChanged(event) {
    event && event.preventDefault();

    if (this.can_submit) {
      this.submitTarget.disabled = false;
      this.submitTarget.classList.remove('cursor-not-allowed', 'opacity-50');
    } else {
      this.submitTarget.disabled = true;
      this.submitTarget.classList.add('cursor-not-allowed', 'opacity-50');
    }

    this.registrationNumberInputTarget.value = this.registrationNumberInputTarget.value.toUpperCase();
  }

  get can_submit() {
    return (
      this.registrationNumberInputTarget.value &&
      this.registrationNumberInputTarget.value.length > 0
    );
  }

  get carController() {
    const carElement = document.querySelector('[data-controller="car"]');
    if (!carElement) return;

    return this.application.getControllerForElementAndIdentifier(carElement, 'car');
  }

  showManualInput(event) {
    event && event.preventDefault();
    this.showManualInputTarget.classList.add('hidden');
    this.createCarManuallyTextTarget.classList.remove('hidden');
    this.manualInputStep1Target.classList.remove('hidden');
  }

  makeChange(event) {
    if (event.target.value && event.target.value.length > 0) {
      this.manualInputStep1Target.classList.remove('has-error');
      const divWithError = this.manualInputStep1Target.querySelector('.field_with_errors')
      if (divWithError) divWithError.classList.remove('field_with_errors');

      this.manualInputStep2Target.classList.remove('hidden');
      this.manualInputStep2Target.focus();
    } else if (event.target.value == '') {
      this.manualInputStep2Target.classList.add('hidden');

      this.yearInputTarget.selectedIndex = 0;
      this.manualInputStep3Target.classList.add('hidden');

      this.fuelTypeInputTarget.selectedIndex = 0;
      this.manualInputStep4Target.classList.add('hidden');

      this.manualInputStep5Target.classList.add('hidden');
    }
  }

  modelChange(event) {
    if (event.target.value && event.target.value.length > 0) {
      this.manualInputStep2Target.classList.remove('has-error');
      const divWithError = this.manualInputStep2Target.querySelector('.field_with_errors')
      if (divWithError) divWithError.classList.remove('field_with_errors');

      this.manualInputStep3Target.classList.remove('hidden');
      this.manualInputStep3Target.focus();
    } else if (event.target.value == '') {
      this.yearInputTarget.selectedIndex = 0;
      this.manualInputStep3Target.classList.add('hidden');

      this.fuelTypeInputTarget.selectedIndex = 0;
      this.manualInputStep4Target.classList.add('hidden');

      this.manualInputStep5Target.classList.add('hidden');
    }
    this.manualInputStep3Target.value = event.target.value;
  }

  yearChange(event) {
    if (event.target.value && event.target.value.length > 0) {
      this.manualInputStep3Target.classList.remove('has-error');
      const divWithError = this.manualInputStep3Target.querySelector('.field_with_errors')
      if (divWithError) divWithError.classList.remove('field_with_errors');

      this.manualInputStep4Target.classList.remove('hidden');
      this.manualInputStep4Target.focus();
    }
    this.manualInputStep4Target.value = event.target.value;
  }

  fuelTypeChange(event) {
    if (event.target.value && event.target.value.length > 0) {
      this.manualInputStep4Target.classList.remove('has-error');
      const divWithError = this.manualInputStep4Target.querySelector('.field_with_errors')
      if (divWithError) divWithError.classList.remove('field_with_errors');

      this.manualInputStep5Target.classList.remove('hidden');
      this.manualInputStep5Target.focus();
    }
    this.manualInputStep5Target.value = event.target.value;
  }
}
